import { getReferencePosition } from "./getReferencePosition";

/**
 * Based on the extended AD data and the current time of the video player, get the mapped
 * timestamp where the audio player should be.
 */
export function getCurrentAudioTime({
  currentVideoTime,
  extended,
}: {
  currentVideoTime: number;
  extended: { pause: number; play: number }[];
}) {
  const referencePosition = getReferencePosition({
    currentVideoTime,
    extended,
  });

  if (referencePosition === undefined) {
    // we haven't passed any pause points yet, so the video and audio positions are equal
    return currentVideoTime;
  }

  // How far are we past the last pause point?
  const differenceMS = currentVideoTime * 1000 - referencePosition.pause;

  const mappedAudioTime = (referencePosition.play + differenceMS) / 1000;

  return mappedAudioTime;
}
